import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';

// Utils
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import addOrRemoveFromArray from '../../../../src/utils/addOrRemoveFromArray';
import getLanguageId from '../../../../src/utils/i18n/getLanguageId';

// Components
import HorizontalContainer from '../../HorizontalContainer/HorizontalContainer';

// Images
import Sport1 from '../../../../public/images/sports/1.png';
import Sport2 from '../../../../public/images/sports/2.png';
import Sport3 from '../../../../public/images/sports/3.png';
import CheckIcon from '../../../../public/icons/circle_check.svg';
import RadioGroup from '../../../molecules/RadioGroup/RadioGroup';

import styles from './MoreFilters.module.scss';

const sportsImg = [Sport1, Sport2, Sport3];

function MoreFilters({
  filters, setFilters, moreFilters,
}) {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const [formats, setFormats] = useState(null);
  const [selectedFormat, setSelectedFormat] = useState(null);

  const handleFilterClick = (filterName, itemId) => {
    if (filters[filterName]) {
      const updated = addOrRemoveFromArray(filters[filterName], itemId);
      setFilters((prev) => ({ ...prev, [filterName]: updated }));
    }
  };

  useEffect(() => {
    if (moreFilters?.formats) {
      setFormats(Object.values(moreFilters.formats).map(
        (f) => ({ name: `format_${f.id}`, formatId: f.id, label: f.name[getLanguageId(locale)] }),
      ));
    }
  }, [moreFilters?.formats]);

  useEffect(() => {
    const selected = selectedFormat ? formats.find((f) => f.name === selectedFormat) : null;
    setFilters((prev) => ({ ...prev, formatId: selected?.formatId || null }));
  }, [selectedFormat]);

  return (
    Object.values(moreFilters).length ? (
      <section className={`${styles.wrapper} m-t-40`}>
        {Object.values(moreFilters.sports)?.length ? (
          <div className={styles.filter_wrapper}>
            <h3 className={styles.filter_title}>{t('filters.type.sports')}</h3>
            <div className="p-relative mobile-p-b-20">
              <HorizontalContainer className="flex-auto">
                {Object.values(moreFilters.sports).map((sport) => (
                  <button
                    key={sport.id}
                    type="button"
                    onClick={() => handleFilterClick('sportIds', sport.id)}
                    className={`${styles.img_bloc} ${filters.sportIds.includes(sport.id) ? styles.selected : ''}`}
                  >
                    <Image
                      src={sportsImg[sport.id - 1]?.src || sportsImg[0]?.src}
                      alt={sport.name[getLanguageId(locale)]}
                      layout="fill"
                      objectFit="cover"
                    />
                    <p className={styles.bloc_title}>
                      {sport.name[getLanguageId(locale)]}
                    </p>
                    <span className={styles.check_icon}>
                      <CheckIcon />
                    </span>
                  </button>
                ))}
              </HorizontalContainer>
            </div>
          </div>
        ) : null}

        {formats?.length ? (
          <div className={`${styles.filter_wrapper}`}>
            <h3 className={styles.filter_title}>{t('filters.type.format')}</h3>
            <div className={styles.filters_list}>
              <RadioGroup
                groupName="formats"
                entries={formats}
                selected={selectedFormat}
                setSelected={setSelectedFormat}
                horizontalScroll
              />
            </div>
          </div>
        ) : null}

        {Object.values(moreFilters.tags)?.length ? (
          <div>
            <h3 className={styles.filter_title}>{t('filters.type.tags')}</h3>
            <div className={styles.filters_list}>
              {Object.values(moreFilters.tags).map((tag) => (
                <button
                  key={tag.id}
                  type="button"
                  className={`${styles.filter_label} ${filters.tagIds.includes(tag.id) ? styles.selected : ''}`}
                  onClick={() => handleFilterClick('tagIds', tag.id)}
                >
                  {tag.name[getLanguageId(locale)]}
                </button>
              ))}
            </div>
          </div>
        ) : null}
      </section>
    ) : null
  );
}

MoreFilters.propTypes = {
  moreFilters: PropTypes.shape({}),
  filters: PropTypes.shape({}),
  setFilters: PropTypes.func,
};

MoreFilters.defaultProps = {
  moreFilters: {},
  filters: {},
  setFilters: () => {},
};

export default MoreFilters;
